module.exports = __webpack_public_path__ + "media/images/badges/cyclebar/grey/RideClub_Milestones_App_100-Grey-d9b14213677ca77b01b3853e3ddfd417.png";